import React, { Suspense } from "react";

const ExternalSignalHire = React.lazy(() => import("@/pages/external-signalhire"));

export default function ExternalSignalHireContainer() {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
        </div>
      }
    >
      <ExternalSignalHire />
    </Suspense>
  );
}
